export default {
	init() {
		// JavaScript to be fired on the home page
	},
	finalize() {

		/*
		 * Accommodation Checker
		 */
		Date.prototype.addDays = function(days) {
			var date = new Date(this.valueOf());
			date.setDate(date.getDate() + days);
			return date;
		}

		const sidebarDesktop = document.querySelector('.sidebar-desktop');
		const sidebarMobile = document.querySelector('.sidebar-mobile');
		const availabilityCalendar = document.querySelector('#availability-calendar');
		var checkAvailabilityInProgress = false;

		if (sidebarDesktop) {
			sidebarDesktop.classList.add('js-active');
			sidebarDesktop.dataset.height = sidebarDesktop.offsetHeight;
			sidebarDesktop.classList.add('mobile-pending');

			const sidebarMobileButton = sidebarMobile.querySelector('.button');

			sidebarMobileButton.addEventListener('click', function(e) {
				e.preventDefault();
				sidebarMobileButton.classList.add('disabled');
				sidebarDesktop.style.setProperty('--height', sidebarDesktop.dataset.height + "px");
				sidebarDesktop.classList.add('active');
				setTimeout(() => {
					sidebarDesktop.style.setProperty('--height', "auto");
				}, 1000);
			});
		}

		if (availabilityCalendar) {
			const bookingLang = availabilityCalendar.dataset.lang;
			const bookingForm = availabilityCalendar.querySelector('form.accommodation-form');
			const bookingURL = bookingForm.dataset.action;
			// const buttonCheckAvailability = bookingForm.querySelector('input.button');

			/* Accom/Date chooser */
			const accommodationSelector = availabilityCalendar.querySelector('#accommodationList');
			const accommodationStartDateSelector = availabilityCalendar.querySelector('#accommodationStartDate');
			const accommodationEndDateSelector = availabilityCalendar.querySelector('#accommodationEndDate');
			const accommodationAllStartDates = availabilityCalendar.querySelectorAll('#accommodationStartDate option.date');
			const accommodationAllEndDates = availabilityCalendar.querySelectorAll('#accommodationAllEndDates option.date');

			/* Results */
			const accommodationResults = availabilityCalendar.querySelector('.accommodation-results');
			const resultTitle = accommodationResults.querySelector('.results_title');
			const resultMessage = accommodationResults.querySelector('.results_message');
			const resultButtonWrapper = accommodationResults.querySelector('.results_buttonwrapper');

			function resultsReset() {
				resultTitle.innerHTML = '';
				resultTitle.classList.remove('active');
				resultMessage.innerHTML = '';
				resultMessage.classList.remove('centre');
				resultButtonWrapper.innerHTML = '';
				accommodationResults.classList.remove('active', 'loaded', 'loading');
			}

			function resultsError() {
				resultTitle.innerHTML = 'Error occurred';
				resultMessage.innerHTML = 'Something has gone wrong with this query.';
				resultButtonWrapper.innerHTML = '';
			}

			function showEndDates() {
				resultsReset();
				const accommodationStartDateSelected = availabilityCalendar.querySelector('#accommodationStartDate option:checked');

				if (accommodationStartDateSelected.value != -1) {
					const startDateSelected = new Date(accommodationStartDateSelected.value);
					const startDatePlusMinDuration = startDateSelected.addDays(parseInt(accommodationStartDateSelected.dataset.min));

					accommodationEndDateSelector.disabled = false;
					const accommodationEndDates = availabilityCalendar.querySelectorAll('#accommodationEndDate option.date');
					accommodationEndDates.forEach(function(accommodationEndDate) {
						accommodationEndDate.remove();
					});

					accommodationAllEndDates.forEach(function(accommodationEndDate) {
						const endDateValue = new Date(accommodationEndDate.value);
						// if (endDateValue > startDateSelected) {
						if (endDateValue >= startDatePlusMinDuration) {
							accommodationEndDate.dataset.active = true;
							accommodationEndDateSelector.appendChild(accommodationEndDate)
							//console.log(accommodationEndDate);
						} else {
							accommodationEndDate.dataset.active = false;
						}
					});

					accommodationEndDateSelector.value = -1;
				} else {
					accommodationEndDateSelector.disabled = true;
					const accommodationEndDates = availabilityCalendar.querySelectorAll('#accommodationEndDate option.date');
					accommodationEndDates.forEach(function(accommodationEndDate) {
						accommodationEndDate.remove();
					});
				}
			}

			function hpmsStartDateQuery() {
				resultsReset();

				const accommodationType = accommodationSelector.value;
				accommodationStartDateSelector.disabled = false;
				const accommodationStartDates = availabilityCalendar.querySelectorAll('#accommodationStartDate option.date');
				accommodationStartDates.forEach(function (accommodationStartDate) {
					accommodationStartDate.remove();
				});

				fetch('//hpms-connect.homeip.net/api/holidayDates/arrival?accommodationType=' + accommodationType+'&token=cbd63599-4f4f-4d17-845a-66dda1f272fd')
					.then(response => {
						response.json().then(parsedJson => {
							parsedJson.forEach(function (accommodationStartDate) {
								//console.log(accommodationStartDate);
								const theDate = new Date(accommodationStartDate.date);
								const day = theDate.toLocaleString('en-gb', { weekday: 'long' });
								const month = theDate.toLocaleDateString(undefined, { month: 'long' });
								const dayOfMonth = theDate.getDate();
								const year = theDate.getFullYear();

								var opt = document.createElement('option');
								opt.value = accommodationStartDate.date;
								opt.innerHTML = day+', '+dayOfMonth+' '+month+' '+year;
								if (accommodationStartDate.description) {
									opt.dataset.description = accommodationStartDate.description;
								} else {
									opt.dataset.description = '';
								}
								opt.dataset.min = accommodationStartDate.minDuration;
								opt.classList.add('date');
								accommodationStartDateSelector.appendChild(opt);

							});

							accommodationEndDateSelector.disabled = true;
							const accommodationEndDates = availabilityCalendar.querySelectorAll('#accommodationEndDate option.date');
							accommodationEndDates.forEach(function (accommodationEndDate) {
								accommodationEndDate.remove();
							});

							showEndDates();
						})
					})
					.catch(error => {
						console.error('There has been a problem with your fetch operation:', error);
						resultsError();
					});
/*
				{% set arrivalDatesURL = '//hpms-connect.homeip.net/api/holidayDates/arrival?accommodationType='~accommodationHpmsID~'&token=cbd63599-4f4f-4d17-845a-66dda1f272fd' %}
				{% set arrivalDates = craft.app.api.client.get(arrivalDatesURL).getBody().__toString() | json_decode %}

				{% if arrivalDates | length %}
								<label for="accommodationStartDate">{{strings.arrivalDatesDropdownLabel ?? 'Check in'}}</label>
								<select name="accommodationStartDate" id="accommodationStartDate">
									<option value="-1" class="base">{{strings.arrivalDatesDropdownDefaultMessage ?? 'Choose a check in date'}}</option>
									{% for arrivalDate in arrivalDates %}
										<option
											value="{{arrivalDate.date}}"
											class="date"
											data-description="{{arrivalDate.description}}"
											data-min="{{arrivalDate.minDuration}}"
										>
											{{arrivalDate.date|date("l, j F Y")}}
										</option>
									{% endfor %}
								</select>
				{% endif %}

				const accommodationStartDateSelected = availabilityCalendar.querySelector('#accommodationStartDate option:checked');

				if (accommodationStartDateSelected.value != -1) {
					const startDateSelected = new Date(accommodationStartDateSelected.value);
					const startDatePlusMinDuration = startDateSelected.addDays(parseInt(accommodationStartDateSelected.dataset.min));

					accommodationEndDateSelector.disabled = false;
					const accommodationEndDates = availabilityCalendar.querySelectorAll('#accommodationEndDate option.date');
					accommodationEndDates.forEach(function (accommodationEndDate) {
						accommodationEndDate.remove();
					});

					accommodationAllEndDates.forEach(function (accommodationEndDate) {
						const endDateValue = new Date(accommodationEndDate.value);
						// if (endDateValue > startDateSelected) {
						if (endDateValue >= startDatePlusMinDuration) {
							accommodationEndDate.dataset.active = true;
							accommodationEndDateSelector.appendChild(accommodationEndDate)
						} else {
							accommodationEndDate.dataset.active = false;
						}
					});

					accommodationEndDateSelector.value = -1;
				} else {
					accommodationEndDateSelector.disabled = true;
					const accommodationEndDates = availabilityCalendar.querySelectorAll('#accommodationEndDate option.date');
					accommodationEndDates.forEach(function (accommodationEndDate) {
						accommodationEndDate.remove();
					});
				}*/
			}

			function hpmsDatesQuery() {
				//console.log('hpmsDateQuery');
				const accommodationSelected = availabilityCalendar.querySelector('#accommodationList option:checked');
				const accommodationStartDateSelected = availabilityCalendar.querySelector('#accommodationStartDate option:checked');
				const accommodationEndDateSelected = availabilityCalendar.querySelector('#accommodationEndDate option:checked');

				if(!checkAvailabilityInProgress) {
					const accommodationEndDates = availabilityCalendar.querySelectorAll('#accommodationEndDate option.date');
					accommodationEndDates.forEach(function (accommodationEndDate) {
						accommodationEndDate.remove();
					});
				}

				// const bookingURL = bookingForm.dataset.action;
				accommodationResults.classList.add('active', 'loading');
				let priceFor;
				if (bookingLang == 'en') {
					priceFor = 'GBP';
				} else {
					priceFor = 'EUR';
				}

				// const bookingURLData = '?arrivalDate=' + accommodationStartDateSelected.value + '&departureDate=' + accommodationEndDateSelected.value + '&accTypeId=' + accommodationSelected.value + '&lang=' + bookingLang; //document.documentElement.lang.toUpperCase()
				const bookingURLData = '?arrivalDate=' + accommodationStartDateSelected.value + '&departureDate=' + accommodationEndDateSelected.value + '&accTypeId=' + accommodationSelected.value + '&lang=' + bookingLang + '&cur=' + priceFor;
				const bookingQueryData = 'accommodation/' + accommodationSelected.value + '/availability?arrivalDate=' + accommodationStartDateSelected.value + '&departureDate=' + accommodationEndDateSelected.value + '&priceFor=' + priceFor + '&token=cbd63599-4f4f-4d17-845a-66dda1f272fd';
				console.log(bookingQueryData);

				// fetch('https://hpms-connect.duckdns.org:8080/api/' + bookingQueryData)
				fetch('https://hpms-connect.homeip.net/api/' + bookingQueryData)
					.then(response => response.json())
					.then(data => handleHpms(data, bookingURLData))
					.catch(error => {
						console.error('There has been a problem with your fetch operation:', error);
						resultsError();
					});
				

				return false;
			}

			function handleHpms(data, bookingURLData) {
				//console.log(data);
				accommodationResults.classList.add('loaded');
				accommodationResults.classList.remove('loading');

				if (data.numAvailable !== null) {
					if (data.numAvailable > 0 && data.price.amount > 10) {
						console.log(data.price.amount);
						// resultTitle.innerHTML = 'Available!';
						resultTitle.innerHTML = resultTitle.dataset.availabletitle;
						resultTitle.classList.add('active');

						const resultAvailableMessageData = resultMessage.dataset.availablemessage;
						const priceTag = '{price}';

						if (bookingLang == 'en') {
							const resultAvailableMessage = resultAvailableMessageData.replace(priceTag, "£" + data.price.amount);
							resultMessage.innerHTML = resultAvailableMessage;
						} else {
							const resultAvailableMessage = resultAvailableMessageData.replace(priceTag, "€" + data.price.amount);
							resultMessage.innerHTML = resultAvailableMessage;
						}
						resultMessage.classList.remove('centre');
						resultButtonWrapper.innerHTML = '<a class="button smaller" href="' + bookingURL + bookingURLData + '">' + resultButtonWrapper.dataset.availabletitle + '</a>';
					} else {
						// resultTitle.innerHTML = '';
						resultTitle.innerHTML = resultTitle.dataset.unavailabletitle;
						if (!resultTitle.dataset.unavailabletitle) {
							resultTitle.classList.remove('active');
						}
						// resultMessage.innerHTML = 'Please email or call us on <a href="tel:01825748318">01825 748318</a> to check.';
						resultMessage.innerHTML = resultMessage.dataset.unavailablemessage;
						resultMessage.classList.add('centre');
						resultButtonWrapper.innerHTML = '<a class="button smaller yellow" href="/contact">' + resultButtonWrapper.dataset.unavailabletitle + '</a>';
					}
				} else {
					resultsError();
				}
			}

			if (accommodationSelector) {
				//console.log(1);
				accommodationSelector.addEventListener('change', function() {

					//console.log(2);

					//Refresh the dates list
					hpmsStartDateQuery();

					accommodationResults.classList.remove('loaded', 'loading');
					if (accommodationEndDateSelector.value != -1) {
						//console.log(3);
						hpmsDatesQuery()
					}
				});
			}

			if (accommodationStartDateSelector) {
				window.onload = function() {
					if (accommodationStartDateSelector.value != -1) {
						showEndDates();
					}
				}

				accommodationStartDateSelector.addEventListener('change', function() {
					showEndDates();
				});
			}

			accommodationEndDateSelector.addEventListener('change', function() {
				// hpmsDatesQuery();
				resultsReset();
			});
			bookingForm.addEventListener('submit', function(event) {
				event.preventDefault();
				checkAvailabilityInProgress = true;
				hpmsDatesQuery();
				checkAvailabilityInProgress = false;
				return false;
			}), true;
		}
	}
}
